import Axios from 'axios';
import { BaseURL, imageUrl, mediaUrl } from '../config/apiUrl';
import { Get } from '../Axios/AxiosFunctions';

/**
 * A short-lived link to a deal room file (or a zip of several). The file
 * routes no longer open without one; the server checks the signed-in user may
 * see the files before it hands the link out.
 */
export async function signedDataRoomUrl(fileIds, accessToken, names) {
  const ids = Array.isArray(fileIds) ? fileIds : [fileIds];
  const route =
    ids.length === 1 && names === undefined
      ? `data-room/file-link/${encodeURIComponent(ids[0])}`
      : `data-room/zip-link?fileIds=${encodeURIComponent(ids.join(','))}&names=${encodeURIComponent(names || '')}`;
  const r = await Get(BaseURL(route), accessToken);
  const path = r?.data?.data?.path;
  return path ? BaseURL(path) : null;
}

/**
 * Link for a file kept in S3 by key. Deal room files there need a short-lived signed
 * link (their keys are timestamps, so they could be guessed); the server checks this
 * user may see the file first. Any other file (not a deal room file) opens by its
 * plain address as before.
 */
export async function signedMediaUrl(key, accessToken, asImage = false) {
  if (!key) return null;
  const r = await Get(BaseURL(`data-room/media-link?key=${encodeURIComponent(key)}`), accessToken, null, false);
  const path = r?.data?.data?.path;
  if (path) return BaseURL(path);
  return asImage ? imageUrl(key) : mediaUrl(key);
}

/** Zip of several S3 files by key, signed the same way. */
export async function signedMediaZipUrl(keys, names, accessToken) {
  const r = await Get(
    BaseURL(`data-room/media-zip-link?keys=${encodeURIComponent(keys)}&names=${encodeURIComponent(names || '')}`),
    accessToken,
    null,
    false,
  );
  const path = r?.data?.data?.path;
  return path ? BaseURL(path) : BaseURL(`download-zip?keys=${keys}&names=${names}`);
}

/**
 * Open a file in a new tab. The tab opens at once (a tab opened after waiting for a
 * link is blocked as a popup), then goes to the link when it arrives.
 */
export function openInNewTab(getUrl) {
  const w = window.open('', '_blank');
  Promise.resolve(getUrl()).then((u) => {
    if (!u) return w && w.close();
    if (w) w.location.href = u;
    else window.open(u, '_blank');
  });
}

const options = {
  onDownloadProgress: (progressEvent) => {
    const { loaded, total } = progressEvent;
  },
};

export function downloadFileFromUrl(fileUrl, filename) {
  Axios.get(fileUrl, {
    responseType: 'blob',
    ...options,
  })
    .then(function (response) {
      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: response.headers['content-type'],
        }),
      );

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    })
    .catch((e) => {});
}
